import React, {useRef} from 'react'
import Form, {FormInputComponent} from "../../../components/form/Form";
import ReactDOM from "react-dom";
import {CommitmentOptions} from './DashboardPreferences';
import {Checkbox, InputNumber, Radio} from "antd";


const PreferenceQuestionnaire = (props) => {
    const formRef = useRef();
    // const initialPreferences = { ...props.preferences };
    const preferences = props.preferences;
    // const [preferences, setPreferences] = useState(initialPreferences);

    const invalidFields = () => {
        if (!formRef.current) {
            return false
        }
        let invalid = formRef.current.forceValidate();
        if (invalid) {
            const node = ReactDOM.findDOMNode(invalid);
            $('html, body').animate({ scrollTop: $(node).offset().top }, 1000);
        }
        return invalid;
    }

    const mapping = (model) => {
        let result = { ...preferences };
        for (let [key, value] of Object.entries(model)) {
            result = TB.set(result, key, value);
        }
        let allTimeZones = Object.values({ ...laravel.talent_questions.time_zones });
        if (result.prefers_any_timezone !== preferences.prefers_any_timezone) {
            if (result.prefers_any_timezone) {
                for (let timeZone of allTimeZones) {
                    result.selected_time_zones[timeZone.id] = true;
                }
            } else {
                result.selected_time_zones = {}
            }
            result.prefers_any_non_us_timezone = result.prefers_any_timezone;
        }
        TB.map(TB.TimeZonesNotInUS(), zone => {
            result.selected_time_zones[zone.value] = result.prefers_any_non_us_timezone;
        })
        let timeZones = []
        TB.map(result.selected_time_zones, (selected, timeZoneId) => {
            if (selected) {
                timeZones.push(parseInt(timeZoneId));
            }
        })
        result.time_zones = timeZones;
        console.log(result, ' resutlttttt')
        return result;
    }

    return (
        <div className="work-preference-form">

            <Form
                ref={formRef}
                showRequired
                className="work-preference-form pref-questionnaire-form"
                background={'transparent'}
                title={null}
                subtitle={null}
                minimal
                submitButton={false}
                mapping={model => mapping(model)}
                onSubmit={null}
                model={preferences}
                onChange={async (model) => {
                    if (props.disabled) return;

                    if(!model.is_available && model.is_available !== props.preferences.is_available) {
                        const confirm = await TB.sysAlert('talent.turn_off_availability_warning');

                        if (!confirm) {
                            return props.onChange(mapping({...model, is_available: true}));
                        }
                    }

                    return props.onChange(mapping(model));
                }}
                fields={[]}
                isDisabled={props.disabled}
            >

                <FormInputComponent
                    fieldName="is_available"
                    value={preferences.is_available}
                    label="Are you available and open to work?"
                    type="antd-input"
                    required={false}
                >
                    <Radio.Group
                        className="flex gap-2 items-center"
                        optionType="button"
                        value={preferences.is_available}
                        buttonStyle="solid"
                    >
                        <Radio value={true}
                               className="flex flex-col items-start justify-center">
                            Yes
                        </Radio>
                        <Radio value={false}
                               className="flex flex-col items-start justify-center">
                            No
                        </Radio>
                        <p className="text-sm ml-2 whitespace-no-wrap">
                            My profile <strong>{preferences.is_available ? 'WILL' : 'WILL NOT'}</strong> show
                            up on the Wripple platform
                        </p>
                    </Radio.Group>
                </FormInputComponent>


                <FormInputComponent
                    value={preferences.talent_commitment_level}
                    fieldName="talent_commitment_level"
                    label="Describe your current work status"
                    type="antd-input"
                >
                    <Radio.Group
                        className="flex gap-4"
                        // optionType="button"
                        // buttonStyle="solid"
                        name="talent_commitment_level"
                    >
                        {Object.keys(CommitmentOptions).map(key => {
                            return (
                                <Radio value={Number(key)}>
                                    <span className="flex flex-col items-start gap-1">
                                        <span className="text-sm font-medium">
                                            {CommitmentOptions[key].title}
                                        </span>
                                        <span className="text-xxs">
                                            {CommitmentOptions[key].description}
                                        </span>
                                    </span>
                                </Radio>
                            )
                        })}
                    </Radio.Group>
                </FormInputComponent>

                <FormInputComponent
                    value={preferences.has_full_time_employment_interest}
                    fieldName="has_full_time_employment_interest"
                    label="Would you be interested in a permanent employment opportunity?"
                    type="antd-input"
                >
                    <Radio.Group
                        className="flex gap-2"
                        optionType="button"
                        buttonStyle="solid"
                    >
                        <Radio value={true}
                               className="flex flex-col items-start justify-center">
                            Yes
                        </Radio>
                        <Radio value={false}
                               className="flex flex-col items-start justify-center">
                            No
                        </Radio>
                    </Radio.Group>
                </FormInputComponent>


                <FormInputComponent
                    value={preferences.available_hours_per_week}
                    fieldName="available_hours_per_week"
                    label="Hours per week typically available for freelancing?"
                    type="antd-input"
                    max={40}
                    pattern={/^\b([1-9]|[1-3][0-9]|40)\b/}
                    min={1}
                    validation={{
                        rules: {
                            isInt: true,
                            matchRegexp: /^\b([1-9]|[1-3][0-9]|40)\b/,
                        },
                        errors: {
                            matchRegexp: "The number of hours must be between 1 and 40",
                            isInt: TB.trans('validation.numeric', {
                                'attribute': 'available hours per week'
                            }),
                        }
                    }}
                >

                    <InputNumber
                        controls={false}
                        className="max-w-48"
                        addonAfter=" hours per week "
                        required={true}/>

                </FormInputComponent>

                <FormInputComponent
                    fieldName="can_travel_for_work"
                    value={preferences.can_travel_for_work}
                    label={TB.trans('talent.project_interests.can_travel_for_work_label')}
                    type="antd-input"
                >
                    <Radio.Group
                        className="flex gap-2"
                        optionType="button"
                        buttonStyle="solid"
                    >
                        <Radio value={true}
                               className="flex flex-col items-start justify-center">
                            Yes
                        </Radio>
                        <Radio value={false}
                               className="flex flex-col items-start justify-center">
                            No
                        </Radio>
                    </Radio.Group>
                </FormInputComponent>

                <div className="form-group flex flex-col items-stretch">
                    <label className="col-form-label">
                        Time zones I will work in:
                    </label>
                    <div className="form-group flex flex-row flex-wrap justify-start items-start max-w-[550px]">
                        {TB.map(TB.TimeZonesInUS(), (zone) => {
                            if (zone.is_in_us) {

                                return (
                                    <div className="basis-1/3" key={zone.id}>
                                        <FormInputComponent
                                            value={preferences.prefers_any_timezone ? true : !!preferences.selected_time_zones?.[zone.id]}
                                            fieldName={`selected_time_zones[${zone.id}]`}
                                            disabled={preferences.prefers_any_timezone}
                                            type='antd-input'
                                            className="mb-0"
                                            label={false}
                                            required={false}
                                        >
                                            <Checkbox
                                                value={undefined}
                                                checked={preferences.prefers_any_timezone ? true : !!preferences.selected_time_zones?.[zone.id]}>
                                                <span className="text-xs">
                                                    {zone.name}
                                                </span>
                                            </Checkbox>

                                        </FormInputComponent>
                                    </div>
                                )
                            }
                            return null
                        })}
                        <div className="basis-1/3">

                            <FormInputComponent
                                value={preferences.prefers_any_non_us_timezone}
                                disabled={preferences.prefers_any_timezone}
                                fieldName="prefers_any_non_us_timezone"
                                type='antd-input'
                                className="mb-0"
                                label={false}
                                required={false}
                            >
                                <Checkbox
                                    value={undefined}
                                    checked={preferences.prefers_any_non_us_timezone}>
                                    <span className="text-xs">
                                        Global (excluding U.S.)
                                    </span>
                                </Checkbox>

                            </FormInputComponent>
                        </div>
                    </div>
                    <hr className="mb-2 mt-0"/>

                    <div className="flex flex-row items-center">
                        <div className="basis-1/2">
                            <FormInputComponent
                                value={preferences.prefers_any_timezone}
                                fieldName="prefers_any_timezone"
                                type='antd-input'
                                className="mb-0"
                                label={false}
                                required={false}
                            >
                                <Checkbox
                                    value={undefined}
                                    checked={preferences.prefers_any_timezone}>
                                    <span className="text-xs">
                                        All of the above
                                    </span>
                                </Checkbox>

                            </FormInputComponent>
                        </div>

                    </div>

                </div>

            </Form>
        </div>
    )
}

export default PreferenceQuestionnaire;